interface PropDetailsAmenitiesProps {
  amenities: string[];
}

const PropDetailsAmenities = ({ amenities }: PropDetailsAmenitiesProps) => {
  if (!amenities?.length) return null;

  return (
    <div className="mt-6">
      <h3 className="font-bold text-base text-main-900 mb-3">Amenities</h3>
      <div className="flex flex-wrap gap-2">
        {amenities.map((amenity: string, index: number) => (
          <div
            key={index}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-[#2d96a7]"
            style={{
              backgroundColor: "rgba(45, 150, 167, 0.08)",
              borderColor: "rgba(45, 150, 167, 0.2)",
            }}
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="shrink-0 opacity-80"
            >
              <circle
                cx="10"
                cy="10"
                r="9"
                stroke="currentColor"
                strokeWidth="2"
              />
              <path
                d="M6 10.5l2.5 2.5L14 8"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-xs font-medium capitalize whitespace-nowrap text-dark-blue">
              {amenity?.replace(/[_-]/g, " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropDetailsAmenities;
